module.exports = __webpack_public_path__ + "img/fachada.fbfadd56.png";